import { createReducer, on } from "@ngrx/store";
import {
  fetchDownlines,
  fetchDownlinesSuccess,
  fetchDownlinesFailure,
  getDownline,
  getDownlineSuccess,
  getDownlineFailure,
  addInvitation,
  addInvitationSuccess,
  addInvitationFailure
} from "./downline.actions";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  selectedItem: {},
  error: null,
  total: 0,
  maxPages: 0,
  perPage: 0,
  currentPage: 0
};

const _downlineReducer = createReducer(
  initialState,
  on(fetchDownlines, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchDownlinesSuccess, (state, { downlines }) => {
    const payload = {
      isLoaded: true,
      data: downlines.data,
      total: downlines.total,
      maxPages: downlines.maxPages,
      perPage: downlines.perPage,
      currentPage: downlines.currentPage,
      selectedItem: {}
    };

    return { ...state, ...payload };
  }),
  on(fetchDownlinesFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(getDownline, (state, { downlineID }) => {
    return state;
  }),
  on(getDownlineSuccess, (state, { downline }) => {
    const payload = {
      selectedItem: downline
    };
    return { ...state, ...payload };
  }),
  on(getDownlineFailure, (state, { error }) => {
    const payload = {
      error
    };
    return { ...state, ...payload };
  }),
  on(addInvitation, (state, { invitation }) => {
    const payload = {
      isLoaded: false,
    };
    return { ...state, ...payload };
  }),
  on(addInvitationSuccess, (state, { invitation }) => {
    const payload = {
      isLoaded: true,
    };
    return { ...state, ...payload };
  }),
  on(addInvitationFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  })

);

export function downlineReducer(state, action) {
  return _downlineReducer(state, action);
}
